module.exports = __webpack_public_path__ + "static/media/drew-icon.7cc5d688.png";